module.exports = __webpack_public_path__ + "img/homePicture.19b718cc.jpg";